import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// import * as dat from 'lil-gui'
// import { DoubleSide } from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import gsap from "gsap";


// Scene
const scene = new THREE.Scene()
/**
 * Base
 */
// Debug
// const gui = new dat.GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')
const text = document.querySelector("p.text")
let DEAD_PLAYERS = 0
let SAFE_PLAYERS = 0

const startBtn = document.querySelector('.start-btn')
// renderer.setClearColor(0xB7C3F3, 0.1)


// Fog
const fog = new THREE.Fog('#262837', 1, 40)
scene.fog = fog


const bgMusic = new Audio('sounds/hahaha.mp3')
bgMusic.loop = true
const winMusic = new Audio('sounds/goldbum.mp3')
const loseMusic = new Audio('sounds/wilhelmscream.mp3')

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()

// const doorColorTexture = textureLoader.load('/textures/door/color.jpg')
// const doorAlphaTexture = textureLoader.load('/textures/door/alpha.jpg')
// const doorAmbientOcclusionTexture = textureLoader.load('/textures/door/ambientOcclusion.jpg')
// const doorHeightTexture = textureLoader.load('/textures/door/height.jpg')
// const doorNormalTexture = textureLoader.load('/textures/door/normal.jpg')
// const doorMetalnessTexture = textureLoader.load('/textures/door/metalness.jpg')
// const doorRoughnessTexture = textureLoader.load('/textures/door/roughness.jpg')

const bricksColorTexture = textureLoader.load('/textures/bricks/color.jpg')
const bricksAmbientOcclusionTexture = textureLoader.load('/textures/bricks/ambientOcclusion.jpg')
const bricksNormalTexture = textureLoader.load('/textures/bricks/normal.jpg')
const bricksRoughnessTexture = textureLoader.load('/textures/bricks/roughness.jpg')

// const abricksColorTexture = textureLoader.load('/textures/bricksold/color.jpg')
// const abricksAmbientOcclusionTexture = textureLoader.load('/textures/bricksold/ambientOcclusion.jpg')
// const abricksNormalTexture = textureLoader.load('/textures/bricksold/normal.jpg')
// const abricksRoughnessTexture = textureLoader.load('/textures/bricksold/roughness.jpg')

const grassColorTexture = textureLoader.load('/textures/grass/color.jpg')
const grassAmbientOcclusionTexture = textureLoader.load('/textures/grass/ambientOcclusion.jpg')
const grassNormalTexture = textureLoader.load('/textures/grass/normal.jpg')
const grassRoughnessTexture = textureLoader.load('/textures/grass/roughness.jpg')


// grassColorTexture.repeat.set(8, 8)
// grassAmbientOcclusionTexture.repeat.set(8, 8)
// grassNormalTexture.repeat.set(8, 8)
// grassRoughnessTexture.repeat.set(8, 8)
grassColorTexture.repeat.set(16, 16)
grassAmbientOcclusionTexture.repeat.set(16, 16)
grassNormalTexture.repeat.set(16, 16)
grassRoughnessTexture.repeat.set(16, 16)

grassColorTexture.wrapS = THREE.RepeatWrapping
grassAmbientOcclusionTexture.wrapS = THREE.RepeatWrapping
grassNormalTexture.wrapS = THREE.RepeatWrapping
grassRoughnessTexture.wrapS = THREE.RepeatWrapping

grassColorTexture.wrapT = THREE.RepeatWrapping
grassAmbientOcclusionTexture.wrapT = THREE.RepeatWrapping
grassNormalTexture.wrapT = THREE.RepeatWrapping
grassRoughnessTexture.wrapT = THREE.RepeatWrapping


const textureloader = new THREE.TextureLoader()
const gradientTexture = textureloader.load('/textures/gradients/3.jpg')

gradientTexture.minFilter = THREE.NearestFilter
gradientTexture.magFilter = THREE.NearestFilter
gradientTexture.generateMipmaps = false

// const loader = new THREE.TextureLoader();
// const bgTexture = loader.load('/textures/background/1g.png');
// scene.background = bgTexture;


// const boundingBoxGeometry = new THREE.PlaneGeometry(3, 3,)
// const bondingBoxMat = new THREE.MeshBasicMaterial({
//     color: 0x000000,
//     transparent: true,
//     opacity: 0.1
// })
// const boundingBox = new THREE.Mesh(boundingBoxGeometry, bondingBoxMat)
// boundingBox.position.x = 0
// boundingBox.position.z = 0



// Global Variables
const start_position = 4.2
const end_position = -start_position



const TIME_LIMIT = 60

let gameStat = "loading"

let isLookingBackward = true



// Track Lane
function createLane(size, positionX, positionZ, positionY, rotY = 0, rotX = 0, color = 0x00000f) {
    const geometryLane = new THREE.BoxGeometry(size.w, size.h, size.d)
    const materialLane = new THREE.MeshBasicMaterial({ color: color })
    const cubeLane = new THREE.Mesh(geometryLane, materialLane)
    cubeLane.position.x = positionX
    cubeLane.position.z = positionZ
    cubeLane.position.y = positionY
    cubeLane.rotation.y = rotY
    cubeLane.rotation.x = rotX
    scene.add(cubeLane)
    return cubeLane
}




// Players
//Player1
// const player1UIBox = new THREE.PlaneGeometry(0.3, 0.3)
// const player1UIMat = new THREE.MeshToonMaterial({
//     color: 0xff0000,
//     gradientMap: gradientTexture

// })
// const player1UI = new THREE.Mesh(player1UIBox, player1UIMat)

// player1.position.x = 2
// player1.position.z = 12.5
// player1.position.y = 2



/**
 * Player 1
 */
// const player1model = new THREE.Group()
// scene.add(player1model)
// let mixerPlayer1 = null
// const Player1 = new GLTFLoader()
// Player1.load(
//     '/models/skeleton/scene.gltf',
//     (gltf) => {
//         gltf.scene.scale.set(1.3, 1.3, 1.3)
//         gltf.scene.position.set(Player)
//         gltf.scene.rotation.y = -1.8
//         player1model.add(gltf.scene)
//         mixerPlayer1 = new THREE.AnimationMixer(gltf.scene)
//         const action = mixerPlayer1.clipAction(gltf.animations[0])
//         action.play()

//         // this.gltf.scene = Player
//     }
// )

//Player2
// const player2model = new THREE.Group()
// scene.add(player2model)
// let mixerPlayer2 = null
// const Player2 = new GLTFLoader()
// Player2.load(
//     '/models/mushroom/scene.gltf',
//     (gltf) => {
//         gltf.scene.scale.set(0.4, 0.4, 0.4)
//         gltf.scene.position.set(3.8, -1, 10.8)
//         gltf.scene.rotation.y = - 1.8
//         scene.add(gltf.scene)
//         mixerPlayer2 = new THREE.AnimationMixer(gltf.scene)
//         const action = mixerPlayer2.clipAction(gltf.animations[0])
//         action.play()
//     }
// )






/**
 * Models
 */
/**
 * Rocks
 */
const gltfLoader = new GLTFLoader()
gltfLoader.load(
    '/models/rock1/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(5.5, 8.5, 3.8)
        gltf.scene.position.set(-6, 0, 4)
        scene.add(gltf.scene)
    }
)
const gltfLoadera = new GLTFLoader()
gltfLoadera.load(
    '/models/rock1/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(6.5, 9.5, 4.8)
        gltf.scene.position.set(-11, 0, 2)
        gltf.scene.rotation.y = 2.7
        scene.add(gltf.scene)
    }
)
const gltfLoaderb = new GLTFLoader()
gltfLoaderb.load(
    '/models/rock1/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(1, 1.5, 1)
        gltf.scene.position.set(-7, -0.5, 7)
        gltf.scene.rotation.y = 0.7
        scene.add(gltf.scene)
    }
)


const gltfLoader1 = new GLTFLoader()
/**
 * Rocks
 */
gltfLoader1.load(
    '/models/rock1/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(2.5, 2.5, 2.5)
        gltf.scene.position.set(6, 0, 4)
        scene.add(gltf.scene)
    }
)
const gltfLoader1a = new GLTFLoader()
/**
 * Rocks
 */
gltfLoader1a.load(
    '/models/rock1/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(13.5, 13.5, 13.5)
        gltf.scene.position.set(9, 0, -3)
        scene.add(gltf.scene)
    }
)

const gltfLoader1b = new GLTFLoader()
/**
 * Rocks
 */
gltfLoader1b.load(
    '/models/rock1/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(3.5, 3.5, 3.5)
        gltf.scene.position.set(6, 0, 7)
        gltf.scene.rotation.y = 3
        scene.add(gltf.scene)
    }
)

const gltfLoader1c = new GLTFLoader()
/**
 * Rocks
 */
gltfLoader1c.load(
    '/models/rock1/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(2.5, 2.5, 2.5)
        gltf.scene.position.set(-7, 0, -6)
        gltf.scene.rotation.y = 3
        scene.add(gltf.scene)
    }
)

const gltfLoader1d = new GLTFLoader()
/**
 * Rocks
 */
gltfLoader1d.load(
    '/models/rock1/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(2.5, 2.5, 2.5)
        gltf.scene.position.set(0, 0, -10)
        gltf.scene.rotation.y = 3
        scene.add(gltf.scene)
    }
)

const gltfLoader2 = new GLTFLoader()
/**
 * Rocks
 */
gltfLoader2.load(
    '/models/rock2/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(3.5, 6.5, 3.5)
        gltf.scene.position.set(-6, 0, -9)
        gltf.scene.rotation.y = 2
        scene.add(gltf.scene)
    }
)

const gltfLoader3 = new GLTFLoader()
/**
 * Rocks
 */
gltfLoader3.load(
    '/models/rock/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(5.5, 8.5, 5.5)
        gltf.scene.position.set(14, 0, -3)
        scene.add(gltf.scene)
    }
)

let mixer = null
const gltfLoaderTree = new GLTFLoader()
/**
 * Tree
 */
gltfLoaderTree.load(
    '/models/tree/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(0.07, 0.07, 0.07)
        gltf.scene.position.set(0, -1.01, -12)
        gltf.scene.rotation.y = 0.5
        scene.add(gltf.scene)
        mixer = new THREE.AnimationMixer(gltf.scene)
        const action = mixer.clipAction(gltf.animations[0])
        action.play()
    }
)

let mixer7 = null
const gltfLoaderTree2 = new GLTFLoader()
/**
 * Tree
 */
gltfLoaderTree2.load(
    '/models/tree/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(0.05, 0.05, 0.05)
        gltf.scene.position.set(9, -1.01, 5)
        gltf.scene.rotation.y = 4
        scene.add(gltf.scene)
        mixer7 = new THREE.AnimationMixer(gltf.scene)
        const action = mixer7.clipAction(gltf.animations[0])
        action.play()
    }
)


const gltfLoaderGrass = new GLTFLoader()
let mixer1 = null
/**
 * RGrass
 */
gltfLoaderGrass.load(
    '/models/grass/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(0.5, 0.5, 0.5)
        gltf.scene.position.set(4, -1, 5)
        scene.add(gltf.scene)
        mixer1 = new THREE.AnimationMixer(gltf.scene)
        const action = mixer1.clipAction(gltf.animations[0])
        action.play()
    }
)

const gltfLoaderGrass1 = new GLTFLoader()
let mixer3 = null
/**
 * RGrass
 */
gltfLoaderGrass1.load(
    '/models/grass/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(0.5, 0.5, 0.5)
        gltf.scene.position.set(-7, -1, 6)
        scene.add(gltf.scene)
        mixer3 = new THREE.AnimationMixer(gltf.scene)
        const action = mixer3.clipAction(gltf.animations[0])
        action.play()
    }
)

const gltfLoaderGrass2 = new GLTFLoader()
let mixer4 = null
/**
 * RGrass
 */
gltfLoaderGrass2.load(
    '/models/grass/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(0.5, 0.5, 0.5)
        gltf.scene.position.set(5, -1, 7)
        scene.add(gltf.scene)
        mixer4 = new THREE.AnimationMixer(gltf.scene)
        const action = mixer4.clipAction(gltf.animations[0])
        action.play()
    }
)

const gltfLoaderGrass3 = new GLTFLoader()
let mixer5 = null
/**
 * RGrass
 */
gltfLoaderGrass3.load(
    '/models/grass/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(0.5, 0.5, 0.5)
        gltf.scene.position.set(4, -1, 5)
        scene.add(gltf.scene)
        mixer5 = new THREE.AnimationMixer(gltf.scene)
        const action = mixer5.clipAction(gltf.animations[0])
        action.play()
    }
)

const gltfLoaderGrass4 = new GLTFLoader()
let mixer6 = null
/**
 * RGrass
 */
gltfLoaderGrass4.load(
    '/models/grass/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(0.5, 0.5, 0.5)
        gltf.scene.position.set(-4, -1, 5)
        scene.add(gltf.scene)
        mixer6 = new THREE.AnimationMixer(gltf.scene)
        const action = mixer6.clipAction(gltf.animations[0])
        action.play()
    }
)

const gltfLoaderGrass5 = new GLTFLoader()
let mixer8 = null
/**
 * RGrass
 */
gltfLoaderGrass5.load(
    '/models/grass/scene.gltf',
    (gltf) => {
        gltf.scene.scale.set(0.5, 0.5, 0.5)
        gltf.scene.position.set(-3, -1, -5)
        scene.add(gltf.scene)
        mixer8 = new THREE.AnimationMixer(gltf.scene)
        const action = mixer8.clipAction(gltf.animations[0])
        action.play()
    }
)



//
//
//
//






/**
 * Enememies
 */


/**
 * Goomba 0
 */
// const goomba = new THREE.Group()
// scene.add(goomba)
// const gltfLoaderg = new GLTFLoader()
// let mixer2 = null
// scene.add(goomba)
// gltfLoaderg.load(
//     '/models/goomba/scene.gltf',
//     (gltf) => {
//         console.log(gltf)
//         gltf.scene.scale.set(0.025, 0.025, 0.025)
//         gltf.scene.position.set(0, -0.8, 0)
//         gltf.scene.rotation.y += -0.3
//         goomba.add(gltf.scene)


//         mixer2 = new THREE.AnimationMixer(gltf.scene)
//         const action = mixer2.clipAction(gltf.animations[0])
//         action.play()
//     }
// )

// const goomba1 = new THREE.Group()
// scene.add(goomba1)
// const gltfLoaderg1 = new GLTFLoader()
// let mixer9 = null
// gltfLoaderg1.load(
//     '/models/goomba/scene.gltf',
//     (gltf) => {
//         console.log(gltf)
//         gltf.scene.scale.set(0.025, 0.025, 0.025)
//         gltf.scene.position.set(0, -0.8, 0)
//         gltf.scene.rotation.y += -0.3
//         goomba1.add(gltf.scene)


//         mixer9 = new THREE.AnimationMixer(gltf.scene)
//         const action = mixer9.clipAction(gltf.animations[0])
//         action.play()
//     }
// )

// const goomba2 = new THREE.Group()
// scene.add(goomba2)
// const gltfLoaderg2 = new GLTFLoader()
// let mixer10 = null
// gltfLoaderg2.load(
//     '/models/goomba/scene.gltf',
//     (gltf) => {
//         console.log(gltf)
//         gltf.scene.scale.set(0.025, 0.025, 0.025)
//         gltf.scene.position.set(0, -0.8, 0)
//         // gltf.scene.rotation.y += -0.3
//         goomba2.add(gltf.scene)


//         mixer10 = new THREE.AnimationMixer(gltf.scene)
//         const action = mixer10.clipAction(gltf.animations[0])
//         action.play()
//     }
// )

// Enemy 3
const goomba3 = new THREE.Group()
scene.add(goomba3)
const gltfLoaderg3 = new GLTFLoader()
let mixer11 = null
class Enemy3 {
    constructor() {
        gltfLoaderg3.load(
            '/models/goomba/scene.gltf',
            (gltf) => {
                // console.log(gltf)
                gltf.scene.scale.set(0.025, 0.025, 0.025)
                gltf.scene.position.set(0, -0.8, 0)
                // gltf.scene.rotation.y += -0.3
                goomba3.add(gltf.scene)
                this.enemy3 = gltf.scene


                mixer11 = new THREE.AnimationMixer(gltf.scene)
                const action = mixer11.clipAction(gltf.animations[0])
                action.play()

            }
        )
        startBtn.innerText = "start"
    }
    lookBackward() {
        gsap.to(this.enemy3.rotation, { y: -3.15, duration: 0.1 })
        setTimeout(() => isLookingBackward = true, 350)
    }
    lookForward() {
        // this.enemy3.rotation.y = 0
        gsap.to(this.enemy3.rotation, { y: 0, duration: 0.1 })
        setTimeout(() => isLookingBackward = false, 850)
    }

    async start() {
        this.lookBackward()
        await delay(Math.random() * 3000) + 3000
        this.lookForward()
        await delay(Math.random() * 6000) + 2000
        this.start()

    }
}


// Track Create function

function createTrack() {
    createLane({ w: start_position * 2, h: 0.05, d: 0.01 }, 0, 11, -1, 0, 0.1)
    createLane({ w: 0.02, h: 0.05, d: 1 }, start_position, 11, -1, -0.35, 0, 0xFF5733)
    createLane({ w: 0.02, h: 0.05, d: 1 }, end_position, 11, -1, 0.35, 0, 0x33FF49)

}
createTrack()




/**
 * 
 */



/**
 * PLAYER
 */

let mixerPlayer1 = null
const Player1 = new GLTFLoader()
class Player {
    constructor(name = "Player", radius, posY, posZ, color) {
        const geometry = new THREE.SphereGeometry(radius, 16, 16)
        const material = new THREE.MeshBasicMaterial({ color })
        const sphere = new THREE.Mesh(geometry, material)
        // sphere.position.set(3.8, -1, 11.2)
        sphere.position.x = start_position
        sphere.position.y = posY
        sphere.position.z = posZ


        scene.add(sphere)
        Player1.load(
            '/models/skeleton/scene.gltf',
            (gltf) => {
                gltf.scene.scale.set(1.3, 1.3, 1.3)
                gltf.scene.position.set(start_position, posY, posZ)
                // gltf.scene.position.x = start_position
                // gltf.scene.position.y = -1
                // gltf.scene.position.z = 11.2
                // console.log(gltf.scene)
                gltf.scene.rotation.y = -1.8
                scene.add(gltf.scene)
                mixerPlayer1 = new THREE.AnimationMixer(gltf.scene)
                const action = mixerPlayer1.clipAction(gltf.animations[0])
                action.play()
                this.player = gltf.scene



            })

        this.player = sphere

        this.playerInfo = {
            positionX: start_position,
            velocity: 0,
            name,
            isDead: false
        }


    }






    run() {
        if (this.playerInfo.isDead) return
        this.playerInfo.velocity = .04
    }

    stop() {
        gsap.to(this.playerInfo, { velocity: 0, duration: 0.1 })
    }

    check() {
        if (this.playerInfo.isDead) return
        if (!isLookingBackward && this.playerInfo.velocity > 0) {
            text.innerText = this.playerInfo.name + " lost!!!"
            this.playerInfo.isDead = true
            this.stop()
            DEAD_PLAYERS++
            loseMusic.play()
            if (DEAD_PLAYERS == players.length) {
                text.innerText = "Everyone lost!!!"
                gameStat = "ended"
            }
            if (DEAD_PLAYERS + SAFE_PLAYERS == players.length) {
                gameStat = "ended"
            }
        }
        if (this.playerInfo.positionX < end_position + .7) {
            text.innerText = this.playerInfo.name + " is safe!!!"
            this.playerInfo.isDead = true
            this.stop()
            SAFE_PLAYERS++
            winMusic.play()
            if (SAFE_PLAYERS == players.length) {
                text.innerText = "Everyone is safe!!!"
                gameStat = "ended"
            }
            if (DEAD_PLAYERS + SAFE_PLAYERS == players.length) {
                gameStat = "ended"
            }
        }
    }

    update() {
        this.check()
        this.playerInfo.positionX -= this.playerInfo.velocity
        this.player.position.x = this.playerInfo.positionX
    }

}
const player = new Player()

let enemy3 = new Enemy3()

function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

const player1 = new Player("Player 1", .0025, -1, 10.8, 0xD1FFC6)
const player2 = new Player("Player 2", .0025, -1, 11.2, 0xFFCFD2)

const players = [
    {
        player: player1,
        key: "ArrowUp",
        name: "Player 1"
    },
    {
        player: player2,
        key: "w",
        name: "Player 2"
    }
]


async function init() {
    await delay(1000)
    text.innerText = "Starting in 3"
    await delay(1000)
    text.innerText = "Starting in 2"
    await delay(1000)
    text.innerText = "Starting in 1"
    await delay(1000)
    text.innerText = "Go!!"
    bgMusic.play()
    startGame()
}



function startGame() {
    gameStat = "started"
    const progressBar = createLane({ w: 8, h: .1, d: 1 }, 0, 0, 0xebaa12)
    progressBar.position.y = -1
    console.log(progressBar)
    progressBar.position.z = 12
    gsap.to(progressBar.scale, { duration: TIME_LIMIT, x: 0, ease: "none" })
    setTimeout(() => {
        if (gameStat != "ended") {
            text.innerText = "Time Out!!!"
            loseMusic.play()
            gameStat = "ended"
        }
    }, TIME_LIMIT * 1000)
    enemy3.start()
}



// init()

// setTimeout(() => {
//     enemy3.start()

// }, 1000)

/**
 * Boshes
 */

const bushGeometry = new THREE.SphereBufferGeometry(1, 16, 16)
const bushMaterial = new THREE.MeshStandardMaterial({ color: '#89c845' })


const bush1 = new THREE.Mesh(bushGeometry, bushMaterial)
bush1.scale.set(0.5, 4.9, 0.5)
bush1.position.set(9, 0, 3.3)

const bush0 = new THREE.Mesh(bushGeometry, bushMaterial)
bush0.scale.set(0.9, 1, 0.8)
bush0.position.set(3.8, -1, 2.7)

const bush0a = new THREE.Mesh(bushGeometry, bushMaterial)
bush0a.scale.set(0.5, 4.2, 0.6)
bush0a.position.set(10, 0, 2.7)

const bush0b = new THREE.Mesh(bushGeometry, bushMaterial)
bush0b.scale.set(0.5, 6.5, 0.6)
bush0b.position.set(9, 0, -2)

const bush2 = new THREE.Mesh(bushGeometry, bushMaterial)
bush2.scale.set(0.7, 1, 0.7)
bush2.position.set(-8.8, -0.5, 5.7)

const bush2a = new THREE.Mesh(bushGeometry, bushMaterial)
bush2a.scale.set(0.3, 0.4, 0.3)
bush2a.position.set(-8, -1, 6.8)

const bush2b = new THREE.Mesh(bushGeometry, bushMaterial)
bush2b.scale.set(0.3, 0.4, 0.3)
bush2b.position.set(-6.8, -1, 6.8)

const bush3 = new THREE.Mesh(bushGeometry, bushMaterial)
bush3.scale.set(0.6, 0.8, 0.5)
bush3.position.set(3, -1, 2.1)

const bush4 = new THREE.Mesh(bushGeometry, bushMaterial)
bush4.scale.set(0.8, 9, 0.9)
bush4.position.set(-9.5, 0, -1.3)
// const bush4a = new THREE.Mesh(bushGeometry, bushMaterial)
// bush4a.scale.set(1, 1, 1)
// bush4a.position.set(-8.5, 0.2, 0.5)
// const bush4b = new THREE.Mesh(bushGeometry, bushMaterial)
// bush4b.scale.set(0.3, 0.4, 0.3)
// bush4b.position.set(-7.5, 0.2, 0.2)

const bush5 = new THREE.Mesh(bushGeometry, bushMaterial)
bush5.scale.set(0.7, 1, 0.7)
bush5.position.set(-0.4, -0.5, -9.3)

const tree = new THREE.Mesh(bushGeometry, bushMaterial)
tree.scale.set(1, 11, 1)
tree.position.set(-9, 1, -9)


scene.add(bush1, bush0, bush0a, bush0b, bush2, bush2a, bush2b, bush3, bush4, bush5, tree)




// Floor
const floor = new THREE.Mesh(
    new THREE.PlaneGeometry(120, 120),
    new THREE.MeshStandardMaterial({
        map: grassColorTexture,
        aoMap: grassAmbientOcclusionTexture,
        normalMap: grassNormalTexture,
        roughnessMap: grassRoughnessTexture
    })
)
floor.geometry.setAttribute(
    'uv2',
    new THREE.Float32BufferAttribute(floor.geometry.attributes.uv.array, 2)
)
floor.rotation.x = - Math.PI * 0.5
floor.position.y = -1
scene.add(floor)


// BackDrop
const backdrop = new THREE.Mesh(
    new THREE.PlaneGeometry(120, 120),
    new THREE.MeshStandardMaterial({
        map: bricksColorTexture,
        aoMap: bricksAmbientOcclusionTexture,
        normalMap: bricksNormalTexture,
        roughnessMap: bricksRoughnessTexture
    })
)
backdrop.geometry.setAttribute(
    'uv2',
    new THREE.Float32BufferAttribute(backdrop.geometry.attributes.uv.array, 2)

)
// backdrop.rotation.x = - Math.PI * 0.5
backdrop.position.z = -16
backdrop.position.y = 5
scene.add(backdrop)




/**
 * Ghosts - Sprites
 */
// const sprite = new THREE.PointLight('#ff00ff', 2, 2)

// const sprite1 = new THREE.PointLight('#00ffff', 2, 3)

// const sprite2 = new THREE.PointLight('#ffff00', 2, 2)

const sprite3 = new THREE.PointLight('#ffff00', 2, 2)

// const spriteP1 = new THREE.PointLight('#ffff00', 5, 5)

// const spriteP2 = new THREE.PointLight('#ffff00', 2, 2)

// scene.add(sprite, sprite3, sprite1, sprite2)

/**
 * GROUP ADD
 * sprite lights attached to enemies
 */
// scene.add(sprite)
// scene.add(sprite1)
// scene.add(sprite2)
goomba3.add(sprite3)

// const P1 = new THREE.Group()
// const P2 = new THREE.Group()
// scene.add(P1, P2)
// P1.add(spriteP1, player1model, Player1)
// P2.add(spriteP2)



/**
 * Lights
 */
// Ambient light
const ambientLight = new THREE.AmbientLight('#b9c55ff', 0.4)
// gui.add(ambientLight, 'intensity').min(0).max(1).step(0.001)
scene.add(ambientLight)

// Directional light
const moonLight = new THREE.DirectionalLight('#b9d5ff', 0.9)
moonLight.position.set(4, 3, - 2)
// gui.add(moonLight, 'intensity').min(0).max(1).step(0.001)
// gui.add(moonLight.position, 'x').min(- 5).max(5).step(0.001)
// gui.add(moonLight.position, 'y').min(- 5).max(5).step(0.001)
// gui.add(moonLight.position, 'z').min(- 5).max(5).step(0.001)
scene.add(moonLight)

// Door Lights
const doorLight = new THREE.PointLight('#ff7d46', 1, 18)
doorLight.position.set(-2, 3.3, 0.5)

// const gLight = new THREE.PointLight('#ff7d46', 1, 6)
// gLight.position.set(4, 3.3, -5.8)

// const archLight = new THREE.PointLight('#ff7d46', 1, 4)
// archLight.position.set(-6, 6.4, 0.5)

scene.add(doorLight)




/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})



/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(65, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 0
camera.position.y = 3
camera.position.z = 15
// camera.lookAt(Player2.position)
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas, text)
controls.enableDamping = true

// Cursor
const cursor = {
    x: 0,
    y: 0
}

// window.addEventListener('mousemove', (event) => {
//     cursor.x = event.clientX / sizes.width - 0.5
//     cursor.y = event.clientY / sizes.height

//     // console.log(cursor.x, cursor.y)
// })





/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas

})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
// renderer.setClearColor('#262837')
// document.body.appendChild(renderer.domElement)

/**
 * Shadows
 */
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap

renderer.shadowMap.enabled = true
moonLight.castShadow = true
doorLight.castShadow = true
// gLight.castShadow = true
// archLight.castShadow = true
// sprite.castShadow = true
// sprite1.castShadow = true
// sprite2.castShadow = true

//drop shadows
// walls.castShadow = true
// house.castShadow = true
// dhouse.castShadow = true
// // rocks.castShadow = true
// gwalls.castShadow = true

bush1.castShadow = true
bush0.castShadow = true
bush0a.castShadow = true
bush0b.castShadow = true
bush2.castShadow = true
bush2a.castShadow = true
bush2b.castShadow = true
bush3.castShadow = true
bush4.castShadow = true
bush5.castShadow = true
tree.castShadow = true
bush1.receiveShadow = true
bush0.receiveShadow = true
bush0a.receiveShadow = true
bush0b.receiveShadow = true
bush2.receiveShadow = true
bush2a.receiveShadow = true
bush2b.receiveShadow = true
bush3.receiveShadow = true
bush4.receiveShadow = true
bush5.receiveShadow = true
tree.receiveShadow = true
// gltfLoaderTree2.castShadow = true
// gltfLoaderTree.castShadow = true

// walls.receiveShadow = true
// house.receiveShadow = true
// dhouse.receiveShadow = true
floor.receiveShadow = true
// rocks.receiveShadow = true
// house.receiveShadow = true
// dhouse.receiveShadow = true
// gwalls.receiveShadow = true
// garagedoor.receiveShadow = true


doorLight.shadow.mapSize.width = 256
doorLight.shadow.mapSize.height = 256
doorLight.shadow.camera.far = 7

// gLight.shadow.mapSize.width = 256
// gLight.shadow.mapSize.height = 256
// gLight.shadow.camera.far = 7

// archLight.shadow.mapSize.width = 256
// archLight.shadow.mapSize.height = 256
// archLight.shadow.camera.far = 7

// sprite.shadow.mapSize.width = 256
// sprite.shadow.mapSize.height = 256
// sprite.shadow.camera.far = 7

// sprite1.shadow.mapSize.width = 256
// sprite1.shadow.mapSize.height = 256
// sprite1.shadow.camera.far = 7

// sprite2.shadow.mapSize.width = 256
// sprite2.shadow.mapSize.height = 256
// sprite2.shadow.camera.far = 7



// create an AudioListener and add it to the camera/scene
// const listener = new THREE.AudioListener();
// goomba3.add(listener);

// // create a global audio source
// const sound = new THREE.Audio(listener);

// load a sound and set it as the Audio object's buffer

// add play button -- TO DO
// const audioLoader = new THREE.AudioLoader();
// audioLoader.load('hahaha.mp3', function (buffer) {
//     sound.setBuffer(buffer);
//     sound.setLoop(true);
//     sound.setVolume(0.6);
//     sound.play();

// });


startBtn.addEventListener('click', () => {
    if (startBtn.innerText == "START") {
        init()
        document.querySelector('.modal').style.display = "none"
    }
})


/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0
const tick = () => {
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // Update Sprite Movement
    // const goombaAngle = elapsedTime * 0.152
    // goomba.position.x = Math.cos(goombaAngle) * (-15 + Math.sin(elapsedTime * 1.72))
    // goomba.position.z = Math.sin(goombaAngle) * 5
    // goomba.rotation.y = Math.sin(elapsedTime * .9)

    // const goomba1Angle = elapsedTime * 0.257
    // goomba1.position.x = Math.cos(goomba1Angle) * (14 + Math.sin(elapsedTime * 1.49))
    // goomba1.position.z = Math.sin(goomba1Angle) * 6.5
    // goomba1.rotation.y = Math.sin(elapsedTime * .9)

    // const goomba2Angle = elapsedTime * 0.354
    // goomba2.position.x = Math.cos(goomba2Angle) * (8 + Math.sin(elapsedTime * 3.1))
    // goomba2.position.z = Math.sin(goomba2Angle) * 3.5
    // goomba2.rotation.y = Math.sin(elapsedTime * 1.9)

    const goomba3Angle = elapsedTime * 0.458
    goomba3.position.x = Math.cos(goomba3Angle) * 3
    // goomba3.position.z = Math.sin(goomba3Angle) * 2
    // goomba3.rotation.y = Math.sin(elapsedTime * .9)

    // const moonAngle = - elapsedTime * 0.03
    // moonLight.position.x = Math.cos(moonAngle) * 8
    // moonLight.position.z = Math.sin(moonAngle) * 8
    // moonLight.position.y = Math.cos(elapsedTime * 3)

    // const goomba2Angle = - elapsedTime * 0.05
    // goomba2.position.x = Math.cos(goomba2Angle) * -5
    // goomba2.position.z = Math.sin(goomba2Angle) * 3
    // goomba2.position.y = Math.sin(elapsedTime * 4) //* Math.random(elapsedTime * 2.5)


    //
    // const P1Angle = - elapsedTime * 0.05
    // P1.position.x = Math.cos(P1Angle) * 6
    // P1.position.z = Math.sin(P1Angle) * -2
    // P1.position.y = Math.sin(elapsedTime * 4) * Math.random(elapsedTime * 2.5)


    // Update controls
    controls.update()
    // Update camera
    camera.position.x = cursor.x
    camera.position.y = cursor.y

    // ... gltf animator

    // if (mixer !== null)
    if (mixer) {
        mixer.update(deltaTime)
    }
    if (mixer1) {
        mixer1.update(deltaTime)
    }
    // if (mixer2) {
    //     mixer2.update(deltaTime)
    // }
    if (mixer3) {
        mixer3.update(deltaTime)
    }
    if (mixer4) {
        mixer4.update(deltaTime)
    }
    if (mixer5) {
        mixer5.update(deltaTime)
    }
    if (mixer6) {
        mixer6.update(deltaTime)
    }
    if (mixer7) {
        mixer7.update(deltaTime)
    }
    if (mixer8) {
        mixer8.update(deltaTime)
    }
    // if (mixer9) {
    //     mixer9.update(deltaTime)
    // }
    // if (mixer10) {
    //     mixer10.update(deltaTime)
    // }
    if (mixer11) {
        mixer11.update(deltaTime)
    }
    if (mixerPlayer1) {
        mixerPlayer1.update(deltaTime)
    }
    // if (mixerPlayer2) {
    //     mixerPlayer2.update(deltaTime)
    // }
    // if (mixer12) {
    //     mixer12.update(deltaTime)
    // }
    // ...

    // Render
    renderer.render(scene, camera)
    players.map(player => player.player.update())
    if (gameStat == "ended") return
    // Call tick again on the next frame
    window.requestAnimationFrame(tick)

    // player.update()
}

tick()

// function animate() {
//     renderer.render(scene, camera)
//     players.map(player => player.player.update())
//     if (gameStat == "ended") return
//     requestAnimationFrame(animate)

// }
// animate()

// window.addEventListener('keydown', (e) => {
//     if (gameStat != "started") return
//     let p = players.find(player => player.key == e.key)
//     if (p) {
//         p.player.run()
//     }
//     // if (e.key == "ArrowUp") {
//     //     player.run()
//     // }
// })

// window.addEventListener('keyup', (e) => {
//     // if (e.key == "ArrowUp") {
//     //     player.stop()
//     // }
//     let p = players.find(player => player.key == e.key)
//     if (p) {
//         p.player.stop()
//     }
// })

window.addEventListener("keydown", function (e) {
    if (gameStat != "started") return
    let p = players.find(player => player.key == e.key)
    if (p) {
        p.player.run()
    }
})
window.addEventListener("keyup", function (e) {
    let p = players.find(player => player.key == e.key)
    if (p) {
        p.player.stop()
    }
})
